__turbopack_context__.v({
  "back": "AuroraForm-module__V7Mf5W__back",
  "body": "AuroraForm-module__V7Mf5W__body",
  "column": "AuroraForm-module__V7Mf5W__column",
  "crest": "AuroraForm-module__V7Mf5W__crest",
  "divider": "AuroraForm-module__V7Mf5W__divider",
  "lang": "AuroraForm-module__V7Mf5W__lang",
  "langButton": "AuroraForm-module__V7Mf5W__langButton",
  "page": "AuroraForm-module__V7Mf5W__page",
  "providerStack": "AuroraForm-module__V7Mf5W__providerStack",
  "subtitle": "AuroraForm-module__V7Mf5W__subtitle",
  "title": "AuroraForm-module__V7Mf5W__title",
});
